module.exports = __webpack_public_path__ + "img/eyes-06.9629848a.svg";